import uuid from 'uuid-random';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { LoginPopup } from '../LoginPopup';

export const loginPopupId = uuid();

export const showLoginPopupAction = ({ onClose, onLogin, title, closeAll } = {}) => addPopupAction({
    id: loginPopupId,
    component: LoginPopup,
    layer: LAYER.LOGIN,
    onLogin,
    onClose,
    title,
    closeAll
});
